module.exports = __webpack_public_path__ + "img/sticker.53493b30.png";